import Navbar from "@/components/feature/Navbar";
import HeroSection from "./components/HeroSection";
import CategorySection from "./components/CategorySection";
import BenefitsSection from "./components/BenefitsSection";
import ComparisonSection from "./components/ComparisonSection";
import ReviewsSection from "./components/ReviewsSection";
import SecuritySection from "./components/SecuritySection";
import FAQSection from "./components/FAQSection";
import ArticlesSection from "./components/ArticlesSection";
import CTASection from "./components/CTASection";
import FooterSection from "./components/FooterSection";

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || "https://usfansspreadsheet.asia";

  return (
    <main>
      <Navbar />
      <HeroSection />
      <CategorySection />
      <BenefitsSection />
      <ComparisonSection />
      <ReviewsSection />
      <SecuritySection />
      <FAQSection />
      <ArticlesSection />
      <CTASection />
      <FooterSection />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "USFansSpreadsheet",
            "url": siteUrl,
            "description": "Kompletny przewodnik, porównania i najlepsze rozwiązania USFansSpreadsheet w 2026 roku.",
            "inLanguage": "pl",
            "potentialAction": {
              "@type": "SearchAction",
              "target": `${siteUrl}/search?q={search_term_string}`,
              "query-input": "required name=search_term_string",
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "USFansSpreadsheet",
            "url": siteUrl,
            "description": "Kompletny przewodnik, porównania i najlepsze rozwiązania USFansSpreadsheet w 2026 roku.",
            "sameAs": [
              "https://kaspreadsheet.com",
            ],
          }),
        }}
      />
    </main>
  );
}